import { gql } from "@apollo/client";

export const USER_NEW_NAV_OPT_OUT = gql`
  mutation UserNewNavOptOut($input: UserNewNavOptOutInput!) {
    userNewNavOptOut(input: $input) {
      viewer {
        newNavOptOutAt
      }
      errors {
        field
        code
      }
    }
  }
`;
